





















































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { UserGroupStoreState } from '@/modules/msw-products/components/msw-user-group/store';
import { State } from 'vuex-class';
import { RootStoreState } from '../../../../store';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwContentToolbar, SwContentToolbarExpand } from '@libs-uuif/shared/sw-content-toolbar';
import { UserGroup } from '../../types';

const cssPrefix = 'list-user-groups';

@Component({
  components: {
    SwCheckbox,
    SwIcon,
    SwFormRow,
    SwForm,
    SwScrollView,
    SwTextfield,
    SwSelect,
    SwExpandableTextfield,
    SwIconButton,
    SwContentToolbar,
    SwContentToolbarExpand,
  },
  directives: {
    tooltip,
  },
})

export default class ListUserGroups extends SwExtendedVue {
  cssPrefix = cssPrefix;

  enterNewUserGroup: boolean = false;
  newUserGroup: string = '';
  addFlag: boolean  = false;
  editFlag: boolean = false;
  createUserGroupTooltipContent: string = '';
  enableCreateUserGroupTooltip: boolean = false;
  editing : boolean = false;
  editUserGroupName: string = '';
  cancelFlag: boolean = false;
  isExpandSearchFilter: boolean = false;
  searchedValue = '';
  upFixClass : boolean = false;
  downFixClass : boolean = false;
  lastSelected1 : string = '';
  lastSelected2 : string = '';
  userGroupSelectionChanged : boolean = false;
  searchedUserGroupFlag = false;
  searchModeOn : boolean = false;
  selectedAffiliate: string = '';
  userGroupListItems: any[] = [];

  @Prop({ type: Boolean, required: true })
  showNewUserGroupBtn: boolean;

  @Prop({ type: Boolean, required: false })
  scrollUserGroupToTop: boolean;

  @Prop({ type:String, required: true })
  selectedTab: string;

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.selectedUserGroup)
  selectedUserGroup: UserGroupStoreState['selectedUserGroup'];

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.hoveredUserGroup)
  hoveredUserGroup: UserGroupStoreState['hoveredUserGroup'];

  @Watch('userGroups', { immediate: true, deep: true })
  onChangeUserGroups() {
    this.loadUserGroups();
    (this.$refs.vScroll as SwScrollView)?.updatePosition(0, true);
  }

  get affiliateGroups(): any {
    return this.$store.getters['MswUserGroupStoreModule/getAffiliateGroups'];
  }

  get affiliateGroupOptions(): SelectOption[] {
    this.selectedAffiliate = '0';
    return this.affiliateGroups?.map((ele: any) => {
      return {
        id: ele?.id?.toString(),
        label: ele?.affiliateGroup,
      };
    });
  }

  get showAffiliateDropdown() {
    return this.$route?.path?.includes('user-groups') && this.affiliateGroups?.length > 1;
  }

  get createUserGroupTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableCreateUserGroupTooltip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.createUserGroupTooltipContent,
    };
  }

  get userGroups() {
    return this.$store.getters['MswUserGroupStoreModule/getUserGroups'] || [];
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'] || [];
  }

  onChangeAffiliate() {
    // on affiliation option change
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    this.$emit('change-tab-id', 'user-groups-help', false);
    const partyGroupIdsFromSelectedAffiliate: any[] = [];
    const filteredUserGroupsFromSelectedAffiliate: any[] = [];
    const availableGroupsCopy: any[] = [...this.userGroups];
    for (const ele of this.affiliateGroups) {
      if (ele?.id?.toString() === this.selectedAffiliate?.toString()) {
        ele?.partyGroupIds?.forEach((partyGroupId: any) => {
          partyGroupIdsFromSelectedAffiliate.push(partyGroupId);
        });
      }
    }

    for (const userGroup of availableGroupsCopy) {
      for (const partyGroup of partyGroupIdsFromSelectedAffiliate) {
        if (partyGroup?.partyGroupId === userGroup?.partyGroupId) {
          filteredUserGroupsFromSelectedAffiliate.push(userGroup);
        }
      }
    }
    this.userGroupListItems = filteredUserGroupsFromSelectedAffiliate;
  }

  handleSearchFilter() {
    if (this.searchedValue.length > 0) {
      this.searchModeOn = false;
      this.userGroupListItems = this.userGroupListItems.filter((each :  any) => each.partyGroupName.toLowerCase()
      .indexOf(this.searchedValue.toLowerCase()) > -1);
      this.searchedUserGroupFlag = true;
      this.searchModeOn = true;
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    } else {
      this.loadUserGroups();
      this.searchedValue = '';
      this.searchedUserGroupFlag = false;
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    }
  }

  searchTenants(e : any) {
    this.searchedValue = e;
  }

  changeExpand() {
    this.isExpandSearchFilter = !this.isExpandSearchFilter;
    if (this.isExpandSearchFilter) {
      this.enterNewUserGroup = false;
    }
    if (this.isExpandSearchFilter) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
      this.$emit('change-tab-id', 'user-groups-help', false);
    } else {
      this.searchedUserGroupFlag ? this.handleSearchFilter() : '';
    }
  }

  closeSearchFilter(e : any) {
    if (!e) {
      this.searchedValue = '';
      this.handleSearchFilter();
    } else {
      this.handleSearchFilter();
    }
  }

  onSearchBlur() {
    if (this.searchedValue.length === 0) {
      this.isExpandSearchFilter = false;
      this.searchedUserGroupFlag ? this.handleSearchFilter() : '';
    }
  }

  addNewUserGroup() {
    this.enterNewUserGroup = !this.enterNewUserGroup;
    if (this.enterNewUserGroup) {
      this.closeSearchFilter(false);
      this.isExpandSearchFilter = false;
    }
    this.enterNewUserGroup ? this.focusTextField() : '';
    this.enableCreateUserGroupTooltip = false;
    this.addFlag = true;
    this.editFlag = false;
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    if (this.enterNewUserGroup) {
      this.$emit('change-tab-id',  'user-group-create-help', false);
    } else {
      this.$emit('change-tab-id', 'user-groups-help', false);
    }
  }

  focusTextField() {
    setTimeout(() => {
      const wrapper2 = document.getElementById('createUserGroup') as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }

  makeDefaultUserGroup(list: any) {
    this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', [list]);
    this.$emit('make-default');
  }

  onSelectUserGroup(list: any) {
    const { partyGroupId = '' } = list || {};
    this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', [list]);
    this.userGroupSelectionChanged = true;
    if (this.hoveredUserGroup.length > 0) {
      if (!this.editFlag) {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
      }
    }
    if (!this.editFlag && !this.cancelFlag) {
      if (this.selectedUserGroup[0] === partyGroupId) {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        this.$emit('change-tab-id', 'user-groups-help', false);
      } else if (this.selectedUserGroup.length > 0) {
        if (!this.editing) {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [partyGroupId]);
        } else {
          this.editing = false;
        }
      } else {
        this.$emit('change-tab-id', 'user-groups-help', false);
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [partyGroupId]);
      }
    } else {
      this.cancelFlag = false;
    }
    if (this.upFixClass) {
      const myScroll = this.$refs.vScroll as HTMLElement;
      const myScroll1 = this.$refs.vScroll as SwScrollView;
      myScroll1.updatePosition(myScroll.scrollTop + 45, true);
    }
    this.upFixClass =  false;
    this.downFixClass = false;
  }

  hoverUserGroup(partyGroupId: string) {
    if (this.selectedUserGroup.length > 0) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    } else {
      if (!this.editFlag) {
        if (this.hoveredUserGroup[0] === partyGroupId) {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
        } else if (this.hoveredUserGroup.length > 0) {
          if (!this.editing) {
            this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
            this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', [partyGroupId]);
          } else {
            this.editing = false;
          }
        } else {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', [partyGroupId]);
        }
      }
    }
  }

  unHoverUserGroup() {
    if (!this.editFlag) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    }
  }

  checkForUserGroup() {
    const isUserGroupNameExist = this.userGroupListItems?.find((item: UserGroup) => item?.partyGroupName?.toLowerCase() === this.newUserGroup?.toLowerCase()) || '';
    return isUserGroupNameExist !== '';
  }

  submitUserGroup() {
    if (this.newUserGroup.trim() !== '') {
      if (this.checkForUserGroup()) {
        if (this.editUserGroupName !== this.newUserGroup) {
          this.enableCreateUserGroupTooltip = true;
          this.createUserGroupTooltipContent = 'User group name already exists';
          this.enterNewUserGroup = true;
        } else {
          this.editFlag = false;
          if (!this.addFlag) { this.editing = true; }
          this.$emit('add-new-user-group', this.newUserGroup , this.addFlag);
          this.$emit('change-tab-id', 'user-groups-help', false);
          this.newUserGroup = '';
          this.enterNewUserGroup = false;
        }
      } else {
        this.editFlag = false;
        if (!this.addFlag) { this.editing = true; }
        this.$emit('add-new-user-group', this.newUserGroup , this.addFlag);
        this.newUserGroup = '';
        this.enterNewUserGroup = false;
      }
    } else {
      this.enableCreateUserGroupTooltip = true;
      this.createUserGroupTooltipContent = 'Enter user group name';
    }
  }

  cancelUserGroup() {
    this.cancelFlag = true;
    // this.$emit('change-tab-id', 'user-groups-help', false);
    this.newUserGroup = '';
    this.enterNewUserGroup = false;
    this.editFlag = false;
  }

  selectedUserGroupName(partyGroupId: any, flag: boolean) {
    if (this.selectedUserGroup.length > 0) {
      // tslint:disable-next-line:max-line-length
      if (this.selectedUserGroup[0] === partyGroupId && (this.lastSelected1 !== this.selectedUserGroup[0] || this.lastSelected2 !== partyGroupId || this.userGroupSelectionChanged)) {
        this.userGroupSelectionChanged = false;
        this.lastSelected1 = this.selectedUserGroup[0];
        this.lastSelected2 = partyGroupId;
        this.$emit('change-tab-id', this.selectedTab, true);
        this.$emit('extend-user-group', flag);
      }
      return this.selectedUserGroup[0] === partyGroupId;
    }
    return false;
  }

  hoveredUserGroupName(partyGroupId: string) {
    return this.hoveredUserGroup[0] === partyGroupId;
  }

  deleteUserGroup(list: any) {
    this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', [list]);
    const message : any = this.$t('userGroups.deleteWarning');
    confirmService.confirm({
      status: 'major',
      title: 'Delete user group',
      message: list?.totalContacts !== '0' ? message : 'Are you sure you want to delete the user group',
      buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.$emit('change-tab-id', 'user-groups-help', false);
        this.$emit('delete-user-group');
      }
    });
  }

  editUserGroup(list: any) {
    const { partyGroupName = '' } = list || {};
    this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', [list]);
    this.enableCreateUserGroupTooltip = false;
    this.newUserGroup = partyGroupName;
    this.editUserGroupName = partyGroupName;
    this.addFlag = false;
    this.editFlag = !this.editFlag;
    this.enterNewUserGroup = true;
  }

  @Watch('scrollUserGroupToTop')
  setScrollUserGroupToTop() {
    if (this.scrollUserGroupToTop) {
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    }
  }

  onEnterGrpName(value: string) {
    this.enableCreateUserGroupTooltip = false;
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enableCreateUserGroupTooltip = true;
        this.createUserGroupTooltipContent = 'User group name should not exceed 50 characters';
        return;
      }
    }
    this.newUserGroup = value;
  }

  onScrollView() {
    if (document.getElementById('selectedRow')) {
      const scrollViewContainer = document.getElementById('scrollNav')!.getBoundingClientRect();
      const selectedUserGroupSection = document.getElementById('selectedRow')!.getBoundingClientRect();

      if (scrollViewContainer?.top > selectedUserGroupSection?.top) this.upFixClass = true;
      if (scrollViewContainer?.top <= selectedUserGroupSection?.top) this.upFixClass = false;

      if (scrollViewContainer?.bottom < selectedUserGroupSection?.bottom) this.downFixClass = true;
      if (scrollViewContainer?.bottom >= selectedUserGroupSection?.bottom - 1) this.downFixClass = false;
    }
  }

  setDefaultUserGroup() {
    const defaultUserGroup = this.userGroups?.filter((ele: any) => ele?.isDefaultGroup?.toLowerCase() === 'true')[0] || '';
    this.$store.commit('MswUserGroupStoreModule/setDefaultUserGroup', defaultUserGroup);
  }

  loadUserGroups() {
    this.setDefaultUserGroup();
    this.userGroupListItems = [...this.userGroups];
  }

  mounted() {
    this.showAffiliateDropdown && this.onChangeAffiliate();
  }

  created() {
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
  }
}
